import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { MemoryCacheService } from './memoryCache.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configUrl = environment.configFile;
  private httpClient = inject(HttpClient);
  private memoryCacheService = inject(MemoryCacheService);

  private readonly CACHE_NAMESPACE = 'config-service';
  private readonly CACHE_KEY = 'app-config';

  getConfig(): Observable<any> {
    return this.memoryCacheService.withCache(this.CACHE_NAMESPACE, this.CACHE_KEY, this.httpClient.get(this.configUrl));
  }

  // Optionally, expose a method to clear config cache if needed
  clearConfigCache(): void {
    this.memoryCacheService.clearCache(this.CACHE_NAMESPACE);
  }
}
